<template>
  <modal title="Export Search Results to Report" ref="modal">
    <div class="q-gutter-y-md">
      <q-input v-model="reportName" label="Report Name" outlined />
    </div>
    <template v-slot:actions>
      <export-to-report-btn
        label="Export"
        :post-search-id="postSearchId"
        :report-name="reportName"
        flat
        @exported="onExport($event, false)"
      />
      <export-to-report-btn
        label="Export & View"
        :post-search-id="postSearchId"
        :report-name="reportName"
        color="primary"
        @exported="onExport($event, true)"
      />
    </template>
  </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ModalMixin } from '@/mixins';
import { Modal as ModalElement, Report } from '@/type';
import Modal from '@/components/modal/Modal.vue';
import ExportToReportBtn from './ExportToReportBtn.vue';

interface Data {
  reportName: string
}

export default defineComponent({
  emits: ['exported'],
  mixins: [ModalMixin],
  components: {
    Modal,
    ExportToReportBtn,
  },
  props: {
    postSearchId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      reportName: '',
    };
  },
  methods: {
    onExport(report: Report, viewReport: boolean) {
      this.$emit('exported', report);
      (this.$refs.modal as ModalElement).hide();
      if (viewReport) {
        this.$router.push(`/reports/${report.id}`);
      }
    },
  },
});
</script>
